import { clean, format, validate } from 'rut.js';
import { ValidatorFn, UntypedFormControl, Validators, AbstractControl, ValidationErrors, FormControl, FormArray } from "@angular/forms";

export function validatorLinkedinFormatFn(): ValidatorFn {

    return (currentControl: UntypedFormControl): { [key: string]: any } => {

        if (currentControl.value && (currentControl.value as string).length > 0) {


            var videoID = matchLinkedInUrl(currentControl.value);

            if (videoID === '') {
                let temp = {};
                temp["linklinkedinformat"] = true;
                return temp;;
            }
        }
    }
}

export function validatorRutFn(isRequired: boolean): ValidatorFn {

    return (currentControl: UntypedFormControl): { [key: string]: any } => {

        if (!currentControl.value || currentControl.value.length < 1) {
            return;
        }

        let value = clean(currentControl.value);

        if (validate(value)) {
            currentControl.clearValidators();
            currentControl.setValue(format(currentControl.value));

            if (isRequired) {
                currentControl.setValidators([Validators.required, validatorRutFn(true)]);
            }
            else {
                currentControl.setValidators([validatorRutFn(false)]);
            }
        }
        else {
            let temp = {};
            temp["invalidRut"] = true;
            return temp;
        }

    }
}

export function validatorSamePassFn(controlPass: UntypedFormControl): ValidatorFn {

    return (currentControl: UntypedFormControl): { [key: string]: any } => {

        if (currentControl.value !== controlPass.value) {
            let temp = {};
            temp["invalidSamePass"] = true;
            return temp;
        }
    }
}




export function validatorMaxWordFn(maxWords: number): ValidatorFn {

    return (currentControl: UntypedFormControl): { [key: string]: any } => {

        if (!currentControl.value)
            return;

        var wordCount = (currentControl.value as string).trim().length > 0 ? (currentControl.value as string).trim().split(/\s+/).length : 0;

        if (wordCount > maxWords) {
            return { maxword: true };
        }
    }
}

export function validatorYoutubeFormatFn(): ValidatorFn {

    return (currentControl: UntypedFormControl): { [key: string]: any } => {

        if (currentControl.value && (currentControl.value as string).length > 0) {


            var videoID = matchYoutubeUrl(currentControl.value);

            if (videoID === '') {
                let temp = {};
                temp["linkyoutubeformat"] = true;
                return temp;;
            }
        }
    }
}

export function noEmailValidatorFn(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value || typeof control.value !== 'string') {
            return null; // Si el control está vacío o no es de tipo string, no se aplica la validación
        }

        const inputValue: string = control.value.replace(/<[^>]*>/g, '');

        const emailRegex = /\S+@\S+\.\S+/; // Expresión regular para identificar correos electrónicos

        if (emailRegex.test(inputValue)) {
            return { 'invalidNoEmail': true }; // Devuelve un objeto si se encuentra un correo electrónico
        }

        return null; // La entrada es válida
    };
}

export function noEmailAndAtValidatorFn(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value || typeof control.value !== 'string') {
            return null; // Si el control está vacío o no es de tipo string, no se aplica la validación
        }

        let inputValue: string = control.value.replace(/<[^>]*>/g, '');

        const emailRegex = /\S+@\S+\.\S+/; // Expresión regular para identificar correos electrónicos

        if (emailRegex.test(inputValue)) {
            return { 'invalidNoEmailAt': true }; // Devuelve un objeto si se encuentra un correo electrónico
        }

        if (inputValue.includes('@')) {
            return { 'invalidNoEmailAt': true };
        }

        return null; // La entrada es válida
    };
}

export function noUrlValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value || typeof control.value !== 'string') {
            return null; // Si el control está vacío o no es de tipo string, no se aplica la validación
        }

        const inputValue: string = control.value.replace(/<[^>]*>/g, '');

        const urlRegex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm

        // Verifica si la entrada coincide con un patrón de URL
        if (urlRegex.test(inputValue)) {
            return { 'invalidNoUrl': true }; // Devuelve un objeto si se encuentra una URL
        }

        return null; // La entrada es válida
    };
}

export function validatorElementsGreaterThanZeroFn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const value = control.value;

        if (!Array.isArray(value))
            return null;

        const hasInvalidElement = value.some((e: any) => Number(e) <= 0);

        if (hasInvalidElement) {
            return { invalidGreaterThanZero: true };
        }

        return null;
    };
}

export function validatorDifferenceWithinLimitFn(limit: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!Array.isArray(value) || value.length < 2) {
            return null;
        }

        const [first, second] = value.map(Number);

        if (Math.abs(first - second) > limit) {
            return { differenceExceedsLimit: true };
        }

        return null;
    };
}

export function validatorAtLeastOneCheckboxLevelFn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control)
            return null;

        if (!(control['controls']?.length > 0))
            return;

        const countSelectedValues = control['controls']
            .map((faParent: FormArray) => faParent.controls.filter((faControlChild: FormControl) => faControlChild.value === true).length)
            .reduce((acc, count) => acc + count, 0);

        if (countSelectedValues === 0) {
            return {
                atLeastOneRequired: true
            }
        }

        return null;
    };
}

export function validatorAtLeastOneCheckboxFn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control)
            return null;

        if (!(control['controls']?.length > 0))
            return;

        const countSelectedValues = control['controls'].filter(control => control.value === true).length;

        if (countSelectedValues === 0) {
            return {
                atLeastOneRequired: true
            }
        }

        return null;
    };
}

function matchLinkedInUrl(url) {
    var p = /^(?:https?:\/\/)?((www|\w\w)\.)?linkedin.com\/((in\/[^\/]+\/?)|(pub\/[^\/]+\/((\w|\d)+\/?){3}))$/;
    var matches = url.match(p);
    if (matches) {
        return matches[1];

    }
    return '';
}

export function matchYoutubeUrl(url) {
    var p = /^(?:https?:\/\/)?(?:www.)?(?:youtu.be\/|youtube.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    var matches = url.match(p);
    if (matches) {
        return matches[1];

    }
    return '';
}